import AbsModule from "../common/AbsModule";
import PurpleUrl from "../purple/PurpleUrl";
import { NETWORK } from "../common/const";

export default class CustomerService extends AbsModule {
    /*
        "고객지원" 관련 기존 옵션값 추출 및 반환 함수
        @param {Object} data - cnbConfig 데이터 (_config / this.moduleData)
        @return {{isShow: string;, url: string;}} -  "고객지원" 관련 기존 옵션값(노출여부, url)
    */
    static getOriginOption(data) {
        const { serviceList } = data || {};
        const { services } = serviceList || {};
        const { CustomerService } = services || {};
        const { isShow, url } = CustomerService || {};

        return { isShow, url };
    }

    /*
        "고객지원" 최신 및 기존 옵션값에서 노출여부(isShow) 반환
        @param {Object} data - cnbConfig 데이터 (_config / this.moduleData)
        @return {Boolean} - "고객지원" 노출 여부
    */
    static setIsShow(data) {
        const { useCs } = data || {};
        const { isShow, url } = CustomerService.getOriginOption(data);
        const defaultIsShow = false;

        return typeof useCs === 'boolean' ? useCs : (typeof isShow === 'boolean' ? isShow : (url ? true : defaultIsShow));
    }

    /*
        "고객지원" url 반환
        @return {String} - "고객지원" url
    */
    getCsUrl() {
        const { env, purpleCheck } = this.com || {};
        const { isPurpleApp } = purpleCheck;
        const { csUrl } = this.moduleData;
        const { url } = CustomerService.getOriginOption(this.moduleData);
        const defaultUrl = `https://${env === NETWORK.rc ? 'rc-' : ''}help.plaync.com/`;
        const returnUrl = csUrl && typeof csUrl === 'string' ? csUrl : (url && typeof url === 'string' ? url : defaultUrl);
        
        return isPurpleApp ? PurpleUrl.setCsUrlAddPurpleAppParam(returnUrl) : returnUrl;
    }
    
    /*
        "고객지원" 새창여부 반환(런처일 경우 새창으로 열어야 함)
        @return {Boolean} - "고객지원" 새창여부
    */
    isTargetBlank() {
        const isLauncher = document.body.classList.contains('launcher');
        return isLauncher;
    }

    /*
        "로그인 여부" - 로그인 전: 고객지원 텍스트 호버 효과 있음 / 로그인 후: 없음 및 폰트 opacity 변화
        @return {Boolean} 로그인 여부
    */
    isLogin() {
        return window.userData.isLogin || false;
    }

    makeMarkup() {
        const url = this.getCsUrl();
        const isTargetBlank = this.isTargetBlank();
        const isLogin = this.isLogin();

        return `<div class="ncc-cs ${isLogin ? 'is-login' : ''}">
            <a href="${url}" ${isTargetBlank ? `target="_blank"` : ''}>
                <span class="ncc-cs__text">${this.com.l10nData.Service["CustomerService"]}</span>
            </a>
        </div>`;
    }
}